import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class RedirectToLocalInterceptor implements HttpInterceptor {
  readonly urlMap = new Map([
    // Uncomment the API endpoint you want to redirect
    // ['ergonomics', '8080'],
    // ['auth', '8081'],
    // ['consent', '8082'],
    // ['training', '8083'],
    // ['media', '8084'],
    // ['enterprises', '8085'],
    // ['identity', '8089'],
  ]);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      const url = req.url;
      const baselessUrl = url.substring(environment.apiDomain.length + 1);
      const apiEndpoint = baselessUrl.split('/')[0];

      if (this.urlMap.has(apiEndpoint)) {
        const newReq = req.clone({ url: `http://localhost:${this.urlMap.get(apiEndpoint)}/${baselessUrl}` });
        return next.handle(newReq);
      }
    } catch (e) {
      console.error('Error getting API endpoint for ' + req.url);
    }

    return next.handle(req);
  }
}
